import Api from '../../services/Api';

export default {
  state: {
    medias: [],
    mediasLoaded: false,
  },
  actions: {
    loadMedias({ commit }) {
      Api.getMedias()
        .then(r => r.data)
        .then(medias => {
          commit('SET_MEDIA', medias);
        })
        .catch(error => {
          this.$log.error(error);
        });
    },
  },
  mutations: {
    SET_MEDIA(state, medias) {
      state.medias = medias;
      state.mediasLoaded = true;
    },
  },
  getters: {
    getMediaById: state => mediaId => {
      var result = null;
      state.medias.forEach(media => {
        if (media) {
          if (media.name === mediaId) {
            result = media;
          }
        }
      });
      return result;
    },
    isMediasLoaded: state => () => {
      return state.mediasLoaded;
    },
  },
};
